import axios from "../lib/axios-config";
const createNewCustomer = (payload)=>axios.post("/customer/create", payload);
const getCustomers = ()=>axios.get("/customer/list");
const editCustomer = (payload)=>axios.put("/customer/update", payload);
const deleteCustomer = (customerId)=>axios.delete("/customer/delete/".concat(customerId));
export const CustomerApi = {
    createNewCustomer,
    getCustomers,
    editCustomer,
    deleteCustomer
};
